import { fundingTrackingDataActionTypes as act } from './fundingTrackingDataActionTypes';
import { callApi, getEndpoint } from '../../../utils/api';
import { createAction } from 'redux-actions';

const ROLLOVER = 'ROLLOVER';
const TRANSFER = 'TRANSFER';
const MAILACHECK = 'MAILACHECK';

export default function fundingTrackingData(
  state = { store: {}, payload: {} },
  action
) {
  switch (action.type) {
    case act.STORE: {
      return {
        ...state,
        isStoreLoaded: true,
        isStoreLoading: false,
        hasStoreFailed: false,
        store: {
          ...state.store,
          ...action.payload,
        },
      };
    }
    case `${act.STORE}_REJECTED`:
    case `${act.STORE}_NO_DATA`: {
      return {
        ...state,
        hasFailed: true,
        error: action?.payload?.body,
        isLoaded: false,
        isLoading: false,
      };
    }
    case `${act.POST}_REJECTED`: {
      return {
        ...state,
        hasFailed: true,
        error: action?.payload?.body,
        isLoaded: false,
        isLoading: false,
      };
    }
    case `${act.POST}_PENDING`: {
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
        hasFailed: false,
      };
    }
    case `${act.POST}_FULFILLED`: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
        payload: action.payload.body,
      };
    }
    case `${act.PUT}_FULFILLED`: {
      return {
        ...state,
        payload: { ...state.payload, ...action.payload },
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
      };
    }
    case `${act.GENERATE}_FULFILLED`: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: false,
        store: {
          ...state.store,
          pdfForm: action.payload.body,
        },
      };
    }
    default:
      return state;
  }
}

export const convertAccountType = (accountType) => {
  switch (accountType) {
    case 'ROTH_IRA':
      return 'Roth IRA';
    case 'TRADITIONAL_IRA':
      return 'Traditional IRA';
    case 'ROLLOVER_IRA':
      return 'Rollover IRA';
    case 'INDIVIDUAL':
      return 'Individual';
    case 'JOINT':
      return 'Joint';
    case 'UGMA_UTMA':
      return 'Ugma Utma';
    default:
      const converted = accountType?.toLowerCase()?.replace('_', ' ');
      return converted?.charAt(0)?.toUpperCase() + converted?.slice(1);
  }
};

export const getUserFundingInfo = (agreementID, fundModule) => {
  return (dispatch) => {
    // eslint-disable-next-line
    callApi(getEndpoint('userFunds')).then((data: any) => {
      if (agreementID) {
        const userAccountFundingData = searchFundObjByAgreementID(
          agreementID,
          data.body
        );
        if (!userAccountFundingData) {
          const notFoundAction = createAction(`${act.STORE}_NO_DATA`)();
          return dispatch(notFoundAction);
        }
        const normalizedAccountType = convertAccountType(
          userAccountFundingData?.agreementType
        );
        const userProductsFundingData = getuserProductsFundingData(data.body);
        let AccountAgreementID = null;
        let AccountAgreementNumber = null;
        // sweep account - brokerage account else mutual fund account
        if (userAccountFundingData?.sweep) {
          AccountAgreementID = userAccountFundingData?.linkedAgreementID;
          AccountAgreementNumber =
            userAccountFundingData?.linkedAgreementNumber;
        } else {
          AccountAgreementID = userAccountFundingData?.agreementID;
          AccountAgreementNumber = userAccountFundingData?.agreementNumber;
        }
        const storeAction = createAction(act.STORE)({
          userAccountFundingData,
          userProductsFundingData,
          normalizedAccountType,
          AccountAgreementID,
          AccountAgreementNumber,
        });
        dispatch(storeAction);
        //
        const postAction = createAction(act.POST)(
          callApi(
            getEndpoint('getFundingTracking'),
            {
              method: 'POST',
            },
            JSON.stringify({
              agreementKey: {
                '@Type': 'AgreementKey',
                agreementID: AccountAgreementID,
                agreementNumber: getAgreementNumber(
                  userAccountFundingData,
                  fundModule
                ),
              },
            })
          )
        );
        dispatch(postAction);
      } else {
        const userProductsFundingData = getuserProductsFundingData(data.body);
        const storeAction = createAction(act.STORE)({
          userProductsFundingData,
        });
        dispatch(storeAction);
      }
    });
  };
};

const searchFundObjByAgreementID = (agreementID, response) => {
  // Loop through the response object
  for (const key in response) {
    const prop = response[key];
    if (typeof prop === 'object' && prop !== null) {
      for (const innerKey in prop) {
        const innerProp = prop[innerKey];
        if (Array.isArray(innerProp)) {
          for (const item of innerProp) {
            // Mutual funds account: agreementID
            // Brokerage account: linkedAgreementID & sweep
            if (
              item?.agreementID === agreementID ||
              (item?.sweep && item?.linkedAgreementID === agreementID)
            ) {
              return item;
            }
          }
        }
      }
    }
  }
};

const getuserProductsFundingData = (fundObj) => {
  /* eslint-disable */
  const productList: any = [];
  // Loop through the response object
  for (const key in fundObj) {
    const prop = fundObj[key];
    if (typeof prop === 'object' && prop !== null) {
      for (const innerKey in prop) {
        const innerProp = prop[innerKey];
        if (Array.isArray(innerProp)) {
          innerProp.forEach((item) => productList.push(item));
        }
      }
    }
  }
  return productList;
};

const getAgreementNumber = (userAccountFundingData, fundModule) => {
  if ([ROLLOVER].includes(fundModule)) {
    return userAccountFundingData?.agreementNumber;
  } else if ([TRANSFER, MAILACHECK].includes(fundModule)) {
    return userAccountFundingData?.linkedAgreementNumber;
  } else {
    return null;
  }
};

export const putFundingTrackingData = (payload) => {
  return (dispatch) => {
    callApi(
      getEndpoint('putFundingTracking'),
      {
        method: 'PUT',
      },
      JSON.stringify(payload)
    )
      .then((response: any) => {
        const action = createAction(act.PUT)({
          payload: payload,
          response: response.body,
        });
        dispatch(action);
      })
      .catch(() => {
        const notFoundAction = createAction(`${act.STORE}_NO_DATA`)();
        return dispatch(notFoundAction);
      });
  };
};

export const putFundingAction = (fundingTrackingData) => {
  return (dispatch) => {
    //
    callApi(
      getEndpoint('putFundingTracking'),
      {
        method: 'PUT',
      },
      JSON.stringify(fundingTrackingData?.payload)
    )
      .then((response: any) => {
        const action = createAction(act.PUT)({
          payload: fundingTrackingData?.payload,
          response: response.body,
        });
        dispatch(action);
        // Funding action request
        const fundingActionPayload = {
          agreementKey: {
            '@Type': 'AgreementKey',
            agreementID: fundingTrackingData?.store?.AccountAgreementID,
            agreementNumber: fundingTrackingData?.store?.AccountAgreementNumber,
          },
          onboardingFundingAction: `TRANSFER_INITIATED`,
        };
        callApi(
          getEndpoint('fundingAction'),
          {
            method: 'PUT',
          },
          JSON.stringify(fundingActionPayload)
        ).catch(() => {
          const errorAct = createAction(`${act.STORE}_REJECTED`)();
          return dispatch(errorAct);
        });
      })
      .catch(() => {
        const errorAct = createAction(`${act.STORE}_REJECTED`)();
        return dispatch(errorAct);
      });
  };
};

export const postPdfFormGeneration = (payload) => {
  return (dispatch) => {
    const action = createAction(act.GENERATE)(
      callApi(
        getEndpoint('generatePdfForm'),
        {
          method: 'POST',
          responseType: 'blob',
          'accept-version': '2.0',
        },
        JSON.stringify(payload)
      )
    );
    dispatch(action);
  };
};

export const NotApplicable = () => {
  return (dispatch) => {
    const notFoundAction = createAction(`${act.STORE}_NO_DATA`)();
    dispatch(notFoundAction);
  };
};
